import { render, staticRenderFns } from "./InputName.vue?vue&type=template&id=5a062afc&"
import script from "./InputName.vue?vue&type=script&lang=js&"
export * from "./InputName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports